---
de:
  budget_import:
    dialog_title: Budgetdaten importieren
    file_too_large: Die Datei ist zu groß
    import_button: Budgetdaten importieren
    invalid_file: Die Datei konnte nicht gelesen werden. Sie ist möglicherweise beschädigt oder im falschen Format.
    no_file_selected: Bitte wählen Sie eine Datei zum Hochladen aus
    select_file: XLSX oder CSV Datei auswählen
    upload: Hochladen
    upload_failed: Datei konnte nicht hochgeladen werden
  budget_tabs:
    charts: Diagramme
    tables: Tabellen
  budgets:
    edit_title: Budget für
